import type { Finish as FinishInput } from "@tosize/shapes/src/types/finish";
import Finish from "../models/Finish";

const FinishFactory = {
	getInstance(input: FinishInput): Finish {
		return new Finish(input);
	},
};

export default FinishFactory;
